const footer = document.querySelector( 'footer' );

if ( footer ) {
  footer.classList.add( 'e-stn--background-svg-animation' );
}
